export default __webpack_public_path__ + "static/media/sortIcon.0e74dd0b.svg";